import React from 'react';

export default function Google({ ...props }) {
  return (
    <svg
      width="131"
      height="43"
      viewBox="0 0 131 43"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}>
      <path
        d="M17.7494 15.3998V19.9318L28.581 19.927C28.2487 22.4266 27.4059 24.2567 26.1248 25.5378C24.545 27.1175 22.0792 28.8562 17.7494 28.8562C11.0742 28.8562 5.85346 23.4765 5.85346 16.8013C5.85346 10.126 11.0742 4.74638 17.7494 4.74638C21.3519 4.74638 23.9816 6.16233 25.9225 7.98285L29.1204 4.78491C26.4137 2.19862 22.8112 0.214355 17.7542 0.214355C8.61313 0.214355 0.926514 7.66016 0.926514 16.8013C0.926514 25.9424 8.61313 33.3882 17.7542 33.3882C22.686 33.3882 26.4089 31.7699 29.3227 28.7358C32.3184 25.7401 33.2479 21.5356 33.2479 18.1353C33.2479 17.124 33.1708 16.1896 33.0215 15.3998H17.7494Z"
        fill="#10284B"
      />
      <path
        d="M109.119 32.7373V1.43213H104.544V32.7373H109.119Z"
        fill="#10284B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M45.7831 33.3924C51.6878 33.3924 56.4991 28.8604 56.4991 22.7101C56.4991 16.5165 51.6878 12.0278 45.7831 12.0278C39.8785 12.0278 35.0671 16.5165 35.0671 22.7101C35.0671 28.8604 39.8785 33.3924 45.7831 33.3924ZM45.7831 16.2372C49.0196 16.2372 51.8082 18.8668 51.8082 22.7101C51.8082 26.5101 49.0196 29.1831 45.7831 29.1831C42.5467 29.1831 39.7581 26.5149 39.7581 22.7101C39.7581 18.8668 42.5467 16.2372 45.7831 16.2372Z"
        fill="#10284B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M68.9042 33.3924C74.8089 33.3924 79.6202 28.8604 79.6202 22.7101C79.6202 16.5165 74.8089 12.0278 68.9042 12.0278C62.9996 12.0278 58.1882 16.5213 58.1882 22.7101C58.1882 28.8604 62.9996 33.3924 68.9042 33.3924ZM68.9042 16.2372C72.1407 16.2372 74.9293 18.8668 74.9293 22.7101C74.9293 26.5101 72.1407 29.1831 68.9042 29.1831C65.6678 29.1831 62.8792 26.5149 62.8792 22.7101C62.8792 18.8668 65.6678 16.2372 68.9042 16.2372Z"
        fill="#10284B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M101.772 12.678V31.8512C101.772 39.7401 97.1197 42.9621 91.6196 42.9621C86.4422 42.9621 83.3261 39.4993 82.151 36.6674L86.2351 34.9673C86.9623 36.7059 88.7443 38.7576 91.6148 38.7576C95.1354 38.7576 97.3171 36.5855 97.3171 32.4966V30.9602H97.1534C96.1034 32.2558 94.0807 33.3876 91.5281 33.3876C86.1869 33.3876 81.2937 28.7351 81.2937 22.7486C81.2937 16.7188 86.1869 12.0278 91.5281 12.0278C94.0758 12.0278 96.0986 13.1596 97.1534 14.4167H97.3171V12.678H101.772ZM97.6494 22.7486C97.6494 18.9872 95.1402 16.2372 91.9471 16.2372C88.7106 16.2372 85.9991 18.9872 85.9991 22.7486C85.9991 26.4715 88.7106 29.1831 91.9471 29.1831C95.1402 29.1831 97.6494 26.4715 97.6494 22.7486Z"
        fill="#10284B"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M126.95 26.2259L130.591 28.6532C129.416 30.3918 126.584 33.3875 121.691 33.3875C115.623 33.3875 111.091 28.6966 111.091 22.7052C111.091 16.3527 115.661 12.0229 121.166 12.0229C126.709 12.0229 129.421 16.4346 130.307 18.8186L130.794 20.0323L116.514 25.9465C117.607 28.0897 119.307 29.183 121.691 29.183C124.08 29.183 125.737 28.0078 126.95 26.2259ZM115.743 22.3825L125.289 18.4188C124.764 17.0848 123.184 16.1552 121.325 16.1552C118.941 16.1552 115.623 18.2599 115.743 22.3825Z"
        fill="#10284B"
      />
    </svg>
  );
}
